(() => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const React = require('react');

  let count = 0;

  function useId() {
    const [id] = React.useState(() => String(count++));
    return id;
  }

  Object.defineProperty(React, 'useId', {
    get: () => useId,
    enumerable: true,
    configurable: true,
  });
})();
